<div *ngIf="busy">
  Be right there... just practicing serves...
</div>

<div *ngIf="!busy">
  <div>
    <div style="text-align:center">
      <img src="/images/t2.png" height="170" />
      <br />
      <h2>Boca Raton Tennis Ladder</h2>
      www.bocatennisladder.com
    </div>
    <br />
    <p>
      Welcome to the greater Boca Raton area tennis ladder. Our goal is to match you up with players at your level
      and get you out on the courts!! Our ladders run approx. every 3 months (4 times a year). They run for about 10 weeks
      of play for points followed by a tournament. There are prizes for point winners and prizes for tournament winners.
    </p>
    <p>
      We also occasionally host tournaments. We had a ton of fun at the Tiebreaker Championship where each player
      had to play 9 tiebreakers in one day. Stay tuned for the next Tiebreaker Championship!
    </p>
    <p *ngIf="REGISTRATION_OPEN">
      We are now signing up players for our ladders. Reigster below or log in and click 'join next ladder'.
      Contact me for more information. <a href="mailto:tennis@elubin.com">tennis&#64;elubin.com</a>
    </p>
    <p *ngIf="!REGISTRATION_OPEN">
      Our Spring 2023 ladder (Feb-Apr) is underway. Contact me for more information. <a href="mailto:tennis@elubin.com">tennis&#64;elubin.com</a>.
      I reserve all rights to add or remove players from the ladder for any reason.
    </p>

    <!--<p>
    If you are interested in joining our
    ladder, email me for more information <a href="mailto:tennis&#64;elubin.com">tennis&#64;elubin.com</a>.
    If you are already registered, log in and click 'next ladder'.
  </p>-->
    <p>
      Cheers!!
      <br />
      Eric
    </p>
    <div style="margin-top: 15px;">
      <button class="btn btn-primary" [routerLink]='["/home"]'>Log in</button>
      <button class="btn btn-primary" *ngIf="REGISTRATION_OPEN" [routerLink]='["/authentication/register"]'>Register for Ladder</button>
    </div>
    <div style="margin: 25px 0;">
      

      <div class="parent">
        <div class="photo-wrapper">
          <div class="photo">
            <img class="img" src="/assets/tennis4.jpg" />
            <br />
            
          </div>
        </div>
        <div class="photo-wrapper">
          <div class="photo">
            <img class="img" src="/assets/vlad_ale.jpg" />
            <br />
            
          </div>
        </div>
        <div class="photo-wrapper">
          <div class="photo">
            <img class="img" src="/assets/tennis5.jpg" />
            <br />
            
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
